import { SETTINGS_DEFAULT_ROUTES, SETTINGS_ROUTES } from './settingsRoutes'

export type SettingsAccess = {
    isSuperUser: boolean
    isOrganicClient: boolean
}

const PROTECTED_ROUTE_CHECKS: Record<
    string,
    (access: SettingsAccess) => boolean
> = {
    [SETTINGS_ROUTES.account.advanced]: (access) => access.isSuperUser,
    [SETTINGS_ROUTES.account.billing]: (access) => access.isOrganicClient,
}

export const canAccessSettingsRoute = (
    href: string,
    access: SettingsAccess,
): boolean => {
    const check = PROTECTED_ROUTE_CHECKS[href]
    return check ? check(access) : true
}

export const getSettingsAccessDeniedRedirect = (href: string): string => {
    if (href.startsWith('/settings/account')) {
        return SETTINGS_DEFAULT_ROUTES.account
    }

    return SETTINGS_DEFAULT_ROUTES.brand
}

export const settingsRouteRequiresClient = (pathname: string): boolean =>
    pathname === SETTINGS_ROUTES.account.billing

const BRAND_BENEFITS_ROUTES = new Set<string>([
    SETTINGS_ROUTES.shopper.benefits,
    SETTINGS_ROUTES.shopper.banners,
])

const PROMOTIONS_ROUTES = new Set<string>([
    SETTINGS_ROUTES.shopper.promotions,
    SETTINGS_ROUTES.shopper.banners,
])

export const getSettingsProviderFlags = (pathname: string) => ({
    includeBrandBenefits: BRAND_BENEFITS_ROUTES.has(pathname),
    includePromotions: PROMOTIONS_ROUTES.has(pathname),
})
